import { Hammer, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { MODULE_META, ROLE_SCOPE } from "@/config/modules";

export default function ModulePage({ id }) {
  const { modules, user } = useAuth();
  const m = modules.find((x) => x.id === id);
  const meta = MODULE_META[id];
  const Icon = meta.icon;
  const soon = m.status === "soon";

  return (
    <div data-testid={`module-page-${id}`}>
      <PageHeader eyebrow="Módulo" title={m.label} subtitle={meta.desc} />
      <div className="relative overflow-hidden grain bg-white rounded-3xl border border-[#E2DDD3] p-6 sm:p-10 fade-up">
        <div className="flex flex-col sm:flex-row gap-6 sm:items-center">
          <span className="h-20 w-20 rounded-2xl bg-[#E8F5E9] text-[#1E4D2B] flex items-center justify-center shrink-0">
            <Icon className="h-10 w-10" />
          </span>
          <div>
            <span data-testid="module-status-badge"
              className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full ${soon ? "bg-[#C86D51]/15 text-[#B05A40]" : "bg-[#E8F5E9] text-[#1E4D2B]"}`}>
              {soon ? <Clock className="h-4 w-4" /> : <Hammer className="h-4 w-4" />}
              {soon ? "Em breve — etapa posterior" : "Estrutura pronta — conteúdo na próxima etapa"}
            </span>
            <p className="mt-4 text-[#1B2A26] text-base sm:text-lg max-w-2xl">
              {soon
                ? "Este módulo já está reservado no menu e no banco de dados, e será desenvolvido em uma etapa futura."
                : "A estrutura de navegação, permissões e banco de dados deste módulo já está preparada. O cadastro e as funcionalidades serão desenvolvidos na próxima etapa."}
            </p>
            <p className="mt-3 text-sm text-[#5C6B66]" data-testid="module-role-scope">{ROLE_SCOPE[user.role]}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
